export { StudentFullName } from './student-full-name';
